"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var InlineOnboardingPanel_1 = __importDefault(require("./InlineOnboardingPanel"));
var Lightbox_1 = __importDefault(require("./Lightbox"));
var TrackableVideo_1 = __importDefault(require("./TrackableVideo"));
var mobx_react_1 = require("mobx-react");
var InlineOnboardingTelemetry_1 = __importDefault(require("./InlineOnboardingTelemetry"));
var InlineOnboarding = (0, mobx_react_1.observer)(function (_a) {
    var title = _a.title, description = _a.description, _b = _a.enabled, enabled = _b === void 0 ? true : _b, video = _a.video, promptId = _a.promptId, tourId = _a.tourId, imageThumbnail = _a.imageThumbnail;
    var _c = __read((0, react_1.useState)(false), 2), lightBoxOpen = _c[0], setLightboxOpen = _c[1];
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var promptHistory = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore.useHistoryDataStore
        .inlinePromptsHistoryStore;
    var tourOrchestrator = (0, inversify_react_1.useInjection)("tourOrchestrator");
    var inlineOnboardingTelemetry = (0, react_1.useMemo)(function () { return new InlineOnboardingTelemetry_1.default(telemetry); }, [telemetry]);
    var userHasDismissedPrompt = promptHistory.hasDismissed(promptId);
    var showOnboarding = enabled && !userHasDismissedPrompt;
    (0, react_1.useEffect)(function () {
        if (showOnboarding) {
            inlineOnboardingTelemetry.trackViewed(promptId);
        }
    }, [showOnboarding, inlineOnboardingTelemetry, promptId]);
    var handleDismissPrompt = function (source) {
        inlineOnboardingTelemetry.trackDismissed(promptId, source);
        promptHistory.dismissedPrompt(promptId);
    };
    var handlePlay = function (source) {
        inlineOnboardingTelemetry.trackVideoOpened(promptId, source);
        setLightboxOpen(true);
    };
    var handleDismissLightbox = function () {
        setLightboxOpen(false);
    };
    var handleVideoClosed = function (statistics) {
        inlineOnboardingTelemetry.trackVideoPlayed(promptId, statistics);
    };
    var handleStartTour = function () {
        tourOrchestrator.startTour({ tourId: tourId });
        inlineOnboardingTelemetry.trackTourStarted(promptId);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(InlineOnboardingPanel_1.default, { show: showOnboarding, title: title, description: description, onDismiss: handleDismissPrompt, onPlay: handlePlay, videoThumbnail: video === null || video === void 0 ? void 0 : video.videoThumbnail, startTour: handleStartTour, tourId: tourId, imageThumbnail: imageThumbnail }),
        react_1.default.createElement(Lightbox_1.default, { show: lightBoxOpen, onDismiss: handleDismissLightbox },
            react_1.default.createElement(TrackableVideo_1.default, { onClose: handleVideoClosed, src: video === null || video === void 0 ? void 0 : video.videoSrc, autoPlay: true, controls: true }))));
});
exports.default = InlineOnboarding;
